import { useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { RMMClient } from '../../../index';
import { GET_MDM_CLIENT_CONFIG_LIST } from '../../../DeviceGraphQL/queries/MDMSettingsPage';

interface UseMDMConfigurationsParams {
  currentPage: number;
  searchCondition?: any;
  skip?: boolean;
}

export const useMDMConfigurations = ({
  currentPage,
  searchCondition,
  skip = false
}: UseMDMConfigurationsParams) => {
  const [hasAnyClients, setHasAnyClients] = useState(false);

  const {
    data: mdmClientConfigList,
    loading: mdmClientConfigListLoading,
    error: mdmClientConfigListError
  } = useQuery(GET_MDM_CLIENT_CONFIG_LIST, {
    variables: {
      pendingSetup: false,
      listInfo: {
        page: currentPage,
        pageSize: 10,
        sort: [
          {
            attribute: 'client.name',
            order: 'ASC'
          }
        ],
        ...(searchCondition && { condition: searchCondition })
      }
    },
    fetchPolicy: 'network-only',
    client: RMMClient,
    skip: skip
  });

  const clients = mdmClientConfigList?.getMDMClientConfigList?.clients || [];
  const listInfo = mdmClientConfigList?.getMDMClientConfigList?.listInfo;
  const totalPages = listInfo
    ? Math.ceil(listInfo.totalCount / listInfo.pageSize)
    : 1;
  const hasClients = clients.length > 0;

  useEffect(() => {
    if (!searchCondition && listInfo) {
      setHasAnyClients(listInfo.totalCount > 0);
    }
  }, [searchCondition, listInfo]);

  return {
    mdmClientConfigList,
    mdmClientConfigListLoading,
    mdmClientConfigListError,
    clients,
    listInfo,
    totalPages,
    hasClients,
    hasAnyClients
  };
};
